import React from 'react';
import GaugeWidget from './GaugeWidget';
import TableWidget from './TableWidget';
import ServiceStatusWidget from './ServiceStatusWidget';
import ChartWidget from './ChartWidget';
import CountWidget from './CountWidget';
import useStore from '../../store/useStore';

const WidgetFactory = ({ widget }) => {
  const { metric_key, display_name, widget_type, config, metric_config } = widget;

  // Subscribe ONLY to this specific metric, not the entire metrics object
  const metricData = useStore((state) => state.metrics[metric_key]);

  // Parse value from metric data
  const getValue = () => {
    if (!metricData || !metricData.value) return null;

    try {
      // If value is already an object, return it
      if (typeof metricData.value === 'object') {
        return metricData.value;
      }
      // If value is a JSON string, parse it
      if (typeof metricData.value === 'string') {
        return JSON.parse(metricData.value);
      }
      return metricData.value;
    } catch (error) {
      console.error('Error parsing metric value:', error);
      return metricData.value;
    }
  };

  const value = getValue();

  // Get configuration from metric_config or widget config
  const widgetConfig = { ...metric_config, ...config };

  // Render appropriate widget based on type
  switch (widget_type) {
    case 'gauge':
      return (
        <GaugeWidget
          title={display_name}
          value={value?.current ?? value ?? 0}
          min={widgetConfig?.min ?? 0}
          max={widgetConfig?.max ?? 100}
          thresholds={widgetConfig?.thresholds || []}
        />
      );

    case 'table':
      return (
        <TableWidget
          title={display_name}
          data={value}
          columns={widgetConfig?.columns || ['Item', 'Count']}
        />
      );

    case 'service_status':
      return (
        <ServiceStatusWidget
          title={display_name}
          services={value || []}
          config={widgetConfig}
        />
      );

    case 'chart':
    case 'line_chart':
    case 'area_chart':
      return (
        <ChartWidget
          title={display_name}
          data={value || []}
          chartType={widget_type === 'area_chart' ? 'area' : 'line'}
          dataKey={widgetConfig?.dataKey || 'value'}
        />
      );

    case 'count':
      return (
        <CountWidget
          title={display_name}
          value={value?.current ?? value ?? 0}
          unit={widgetConfig?.unit || ''}
          trend={value?.trend ?? null}
          config={widgetConfig}
        />
      );

    default:
      return (
        <div className="widget">
          <div className="widget-header">
            <span className="widget-title">{display_name}</span>
          </div>
          <div className="widget-body">
            <div style={{ color: '#b0b0b0' }}>Unknown widget type: {widget_type}</div>
          </div>
        </div>
      );
  }
};

export default WidgetFactory;
